export function TabSubmissions() {
  return (
    <div>
      <h1 className="text-3xl font-bold">Tab Submissions</h1>
    </div>
  );
}

